import React, { useEffect, useRef } from 'react';
import { getDevice } from '@panel/commons/helpers';
import { isZonaDemandSite } from '@panel/commons/helpers/siteUtils';
import { sendCustomTrackingInfo } from '@panel/commons';
import Inicio from './Inicio';
import AdditionalInfo from './AdditionalInfo';
import MapSection from './MapSection';
import PlansSection from './PlansSection';
import ContactAndSupport from './ContactAndSupport';
import { Container } from './styles';
import Footer from './Footer';
import FAQs from './FAQs';

const ZonaDemandContainer = () => {
  const device = getDevice();
  const mapRef = useRef(null);
  const plansRef = useRef(null);

  const handleClick = (ref, position) => {
    return ref.current && ref.current.scrollIntoView({ behavior: 'smooth', block: position });
  };

  useEffect(() => {
    if (!isZonaDemandSite) {
      window.location = '/';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sendCustomTrackingInfo({
      event: 'track_content_group',
      content_group: 'Landing Zona Demand'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isZonaDemandSite) return <></>;
  return (
    <Container>
      <Inicio device={device} handleClick={handleClick} mapRef={mapRef} plansRef={plansRef} />
      <AdditionalInfo device={device} />
      <MapSection device={device} handleClick={handleClick} mapRef={mapRef} plansRef={plansRef} />
      <PlansSection device={device} plansRef={plansRef} />
      <FAQs device={device} />
      <ContactAndSupport device={device} />
      <Footer device={device} />
    </Container>
  );
};

export default ZonaDemandContainer;
